import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6ba699"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LegalPage__Container view-default__inner bg-gradient" }
const _hoisted_2 = { class: "LegalPage__Background" }
const _hoisted_3 = { class: "LegalPage__Inner" }
const _hoisted_4 = { class: "Aside" }
const _hoisted_5 = { class: "Nav" }
const _hoisted_6 = {
  key: 0,
  class: "Nav__Link is-active"
}
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = { class: "Main" }
const _hoisted_9 = ["innerHTML"]

import { ref, watch } from 'vue'
import legalPage, { PAGES } from '@/store/modules/LegalPage'


import { defineComponent } from 'vue'

const __default__ = defineComponent({})

function setup(__props) {

const root = ref(null)
watch(
  () => [legalPage.page, legalPage.isOpen],
  () => {
    // reset scroll when page changes
    root.value.scrollTop = 0
  }
)

return (_ctx: any,_cache: any) => {
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_heading = _resolveComponent("heading")!

  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    },
    class: "LegalPage view-default z-legal-page"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_inset_border)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PAGES), (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                class: "Nav__Item"
              }, [
                (page === _unref(legalPage).page)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_6, [
                      _createVNode(_component_heading, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`${page}.title`)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "Nav__Link",
                      href: `#${page}`,
                      onClick: _withModifiers(($event: any) => (_unref(legalPage).open(page)), ["prevent"])
                    }, [
                      _createVNode(_component_heading, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`${page}.title`)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_7))
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "Content text",
            innerHTML: _ctx.$t(`${_unref(legalPage).page}.content`)
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ], 512))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})